export enum AccessibilityHtmlTags {
  MainHeading = 'h1',
  SecondaryHeading = 'h2',
  ThirdHeading = 'h3',
  Paragraph = 'p',
}

export type AccessibilityAttributes = {
  role?: string;
  'aria-labelledby'?: string;
  'aria-label'?: string;
};
